window.Utils = {

	enableHeartbeat: function() {
		var url = App.webRoot + 'keepAlive';

		setInterval(function() {
			$.get(url, function(data) {
				var d = new Date();
                var n = d.getTime();
                console.log('[' + n + '] - ' + data);

			});
		}, 300000);
	},

	hideForMobile : function(ele) {
		$(ele).addClass('hidden-xs hidden-sm')
	},

	makeVideoIframesResponsives: function() {
		var $allVideos = $("iframe[src^='//www.youtube.com']"),
		
		// The element that is fluid width
		$fluidEl = $("body");

		// Figure out and save aspect ratio for each video
		$allVideos.each(function() {
		  $(this)
		    .data('aspectRatio', this.height / this.width)

		    // and remove the hard coded width/height
		    .removeAttr('height')
		    .removeAttr('width');

		});

		// When the window is resized
		$(window).resize(function() {
		  var newWidth = $fluidEl.width();

		  // Resize all videos according to their own aspect ratio
		  $allVideos.each(function() {

		    var $el = $(this);
		    $el
		      .width(newWidth)
		      .height(newWidth * $el.data('aspectRatio'));

		  });

		// Kick off one resize to fix all videos on page load
		}).resize();
	},

	responsifyVideos: function () {
		var $allVideos = $('.videodetector');

		$allVideos.each(function() {
		  var t = $(this);
		  if (t.children('iframe').length) {
		  	    //I love bootstrap
		  		t.addClass('embed-responsive embed-responsive-16by9');
		  }
		});

	},

	loadAjaxContent: function(sURL,sClass,sLoading,iTimeOut, callback) {
		return new Promise((res,rej) => {

			if (!iTimeOut) {
				iTimeOut = 8000;
			}
			$(sLoading).show();
			$.ajax({
				type: 'POST',
				url: sURL,
				dataType: 'html',
				cache: false,
				timeout: iTimeOut,
				success: function(data) {
					$(sLoading).hide();
					$(sClass).html(data);
					res(data);
					return true;
				},
				error: function (jqXHR, textStatus, errorThrown) {
					switch (textStatus) {
						case 'timeout'	:	$(sClass).html('<div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button><strong><a href=\"#\" onClick=\"CarregaConteudoAjax(sURL,sClass,sLoading)\">Tentar novamente</a></strong></div>');
							break;
						default         : 	$(sClass).html('<div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button><strong><a href=\"#\" onClick=\"CarregaConteudoAjax(sURL,sClass,sLoading)\">Tentar novamente</a></strong></div>'+errorThrown);
							break;
					}
					rej(errorThrown);

					return false;
				}
			});
		});
	},

	countrySelectorAfterAct : function(country_id) {
		if (country_id==5) {
			$('#divSeletorEstado').show();
			$('#divSeletorCidade').show();
			$('#divInputEstado').hide();
			$('#divInputCidade').hide();
			$('#fieldCNPJ').show();
			$('.input-cep-container').show();
			Utils.loadAjaxContent(App.webRoot+'ajaxListaEstados/5','#estado','#divLoadingEstado',10000);
		} else {
			$('#divSeletorEstado').hide();
			$('#divSeletorCidade').hide();
			$('#divInputEstado').show();
			$('#divInputCidade').show();
            $('#fieldCNPJ').hide();
            $('.input-cep-container').hide();
		}
	},
	cepFillAfterAct : function(cep){
		if(CEPAutoFillComponent.parseCEP(cep).toString().trim().length === 8){
			$('#cidade,#estado,#inputEnderecoRua,#inputEnderecoBairro').attr('disabled',true);
			CEPAutoFillComponent.get(cep)
				.then((address) => {
					$('#inputCEP').attr('data-state',address.uf);
					$('#inputCEP').attr('data-city',address.cidade);
					setTimeout(function(){
						$('#estado').val(address.uf).change();
						$('#inputEnderecoRua').val(address.logradouro);
						$('#inputEnderecoBairro').val(address.bairro);
						$('#cidade,#estado,#inputEnderecoRua,#inputEnderecoBairro').attr('disabled',false);
					},100);
				})
				.catch((e) => {

					$('#inputCEP').removeAttr('data-state');
					$('#inputCEP').removeAttr('data-city');
					$('#estado').val('').change();
					$('#inputEnderecoRua').val("");
					$('#inputEnderecoBairro').val("");
					$('#cidade,#estado,#inputEnderecoRua,#inputEnderecoBairro').attr('disabled',false);
			});
		}
	},
	citySelectorAfterAct: function(sigla_estado,cidade) {
		$('#divSeletorCidade').show();
		$('#divInputCidade').hide();

		Utils
			.loadAjaxContent(App.webRoot+'ajaxListaCidadesDoEstado/'+sigla_estado,'#cidade','#divLoadingCidade',10000)
			.then(() => {
				$('#cidade option').each(function(){
					if(cidade && cidade.toString().trim() === $(this).html().toString().trim()){
						$('#cidade').val($(this).attr('value'))
					}
				});
			});
	},

	verificaEmail: function(sURL,sEmail, sDesconsiderar) {
		var bIgnora = false;
		let valid = false;
	    $('#btnCriar').prop('disabled',true);
	    $('#btnCriar').attr('disabled',true);
		if (sDesconsiderar) {
			if (sEmail==sDesconsiderar) {
				$('#emailExiste').val('');
				$('#spanMensagemErro').html('');
				$('#btnCriar').prop('disabled',false);
				$('#btnCriar').attr('disabled',false);
				bIgnora = true;
				valid = true;
			}
		}

		//Email required
		if(sEmail.length <= 0){
	        $('#spanMensagemErro').html('<div class=\"alert alert-danger\"><strong>Este campo é obrigatório.</strong></div>');
	        $('#btnCriar').prop('disabled', true);
	        $('#btnCriar').attr('disabled', true);
	        valid = false;
		}

		if (!bIgnora && sEmail.length > 0) {
			$('#divLoadingEmail').show();
			$.ajax({
				type: 'POST',
				url: sURL,
				dataType: 'json',
				data: {email: sEmail},
				cache: false,
				timeout: 10000,
				async: false,
				success: function (json) {
					$('#divLoadingEmail').hide();
					if (json.retorno == 'existe') {
						$('#emailExiste').val('em uso');
						// console.log('Email ' + sEmail + ' em uso em outro cadastro');
						$('#spanMensagemErro').html('<div class=\"alert alert-danger\"><strong>Este email já está cadastrado. Por favor, escolha outro.</strong></div>');
						$('#btnCriar').prop('disabled', true);
						$('#btnCriar').attr('disabled', true);
						$('.btn-register').prop('disabled', true);
						$('.btn-register').attr('disabled', true);
						valid = false;
					}
					else {
						$('#emailExiste').val('');
						$('#spanMensagemErro').html('');
						$('#btnCriar').prop('disabled', false);
						$('#btnCriar').attr('disabled', false);
						$('.btn-register').prop('disabled', false);
						$('.btn-register').attr('disabled', false);
						valid = true;
					}
				},
				error: function (jqXHR, textStatus, errorThrown) {
					$('#btnCriar').prop('disabled', false);
					$('#btnCriar').attr('disabled', false);
					$('.btn-register').prop('disabled', false);
					$('.btn-register').attr('disabled', false);
					switch (textStatus) {
						case 'timeout'    :
							$('#spanMensagemErro').html('<div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button><strong><a href=\"#\" onClick=\"CarregaConteudoAjax(sURL,sClass,sLoading)\">Tentar novamente</a></strong></div>');
							break;
						default         :
							$('#spanMensagemErro').html('<div class=\"alert alert-info\"><button type=\"button\" class=\"close\" data-dismiss=\"alert\">&times;</button><strong><a href=\"#\">Erro: </a></strong>' + errorThrown + '</div>');
							break;
					}
					valid = false;
				}
			});
		}
		return valid;
	},

	escondeMostraCPF: function(sIdPais) {
		if (sIdPais==5) {
			$('#blocoBrasil').show();
			$('.inputTelefoneResidencial').show();
			$('.cpf').show();
			$('#inputEnderecoBairro').val('');
			$('#inputCEP').val('');
			$('#inputTelefoneResidencial').val('');
		}
		else {
			$('#blocoBrasil').hide();
			$('.inputTelefoneResidencial').hide();
			$('.cpf').hide();
			$('#inputEnderecoBairro').val('sem bairro');
			$('#inputCEP').val('00000-000');
			//$('#inputTelefoneResidencial').val('(00)0000-0000');
		}
	},

	beginTransits: function(transtioner) {
		var transition = $(transitioner);
        transition.children().fadeOut(500);

        var loader = $('<div></div>').addClass('loader');
        transition.html(loader);
	},

	endTransits: function(t) {
		$(t).hide();
	},

	goToSidebarTop: function() {
		$('html, body').animate({
        	
        	scrollTop: $(".panel-sidebar").offset().top - 120
    	}, 1000);
	},
	formatDate: function (date) {
        let dateOnlyNumbersArray=date.toString().match(/([0-9])/g).join('').toString(),
			date_formated={
				day: dateOnlyNumbersArray.substr(0,2),
				month: dateOnlyNumbersArray.substr(2,2),
				year: dateOnlyNumbersArray.substr(4,4)
			};
        return date_formated;
    }
}